"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAiModel = void 0;
var OpenAiModel;
(function (OpenAiModel) {
    OpenAiModel["GPT_3_5_TURBO_1106"] = "gpt-3.5-turbo-1106";
    OpenAiModel["GPT_4_1106_PREVIEW"] = "gpt-4-1106-preview";
    OpenAiModel["GPT_4O"] = "gpt-4o";
    OpenAiModel["GPT_4_TURBO"] = "gpt-4-turbo";
    OpenAiModel["GPT_4O_MINI"] = "gpt-4o-mini";
    OpenAiModel["GPT_4O_2024_08_06"] = "gpt-4o-2024-08-06";
    OpenAiModel["GPT_O3_MINI"] = "o3-mini";
    OpenAiModel["GPT_5_1"] = "gpt-5.1";
    OpenAiModel["GPT_5_4_MINI"] = "gpt-5.4-mini";
    OpenAiModel["GPT_6_SOL"] = "gpt-6-sol";
    OpenAiModel["GPT_6_ASTRA"] = "gpt-6-astra";
})(OpenAiModel || (exports.OpenAiModel = OpenAiModel = {}));
